/**
 * Created by francesco on 29/09/17.
 */
export class WizardSteps {
	static DELIVERY_DASHBOARD = 'deliveryDashboard';

	static DELIVERY_DASHBOARD_STEPS = [
        {
			element: '#step_one_element_id',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Sei nella sezione Consegna Nuovo</span></h3></div><div class="introjs-content">Qui puoi gestire tutte le procedure di preparazione e consegna di un ordine.</div>',
            position: 'bottom',
            tooltipClass: 'introjs-tooltip--first'
		},
		{
			element: '#step_two_element_id',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Centro di assistenza</span></h3></div><div class="introjs-content">Seleziona da qui il centro per il quale stai operando.</div>',
			position: 'bottom'
		},
		{
			element: '#step_three_element_id',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Menu orizzontale</span></h3></div><div class="introjs-content">È il classico menu di navigazione per accedere alle singole pagine della sezione.</div>',
			position: 'bottom-middle',
			tooltipClass: 'introjs-tooltip--middle'
		},
		{
			element: '#step_four_element_id',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Dashboard</span></h3></div><div class="introjs-content">È la prima pagina che visualizzi: ti offre un accesso veloce a tutti gli strumenti necessari all’elaborazione degli ordini.</div>',
			position: 'bottom'
		},
		{
			element: '#step_five_element_id',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Fascia ordini</span></h3></div><div class="introjs-content">Hai 5 contatori, uno per ogni stato di consegna. Al click su un box vai all’elenco completo degli ordini al suo interno.</div>',
			position: 'bottom'
		},
		{
			element: '#step_six_element_id',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Se hai bisogno sono qui</span></h3></div><div class="introjs-content">Usa questa icona per conoscere le principali funzionalità della pagina in cui ti trovi.</div>',
			position: 'bottom'
		}
	];

	static ORDERS_LIST = 'ordersList';

	static ORDERS_LIST_STEPS = [
		{
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Sei nella pagina Ordini</span></h3></div><div class="introjs-content">Qui puoi gestire tutti gli ordini relativi al centro assistenza selezionato.</div>'
		},
		{
			element: '#step_list_one',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Ricerca un ordine</span></h3></div><div class="introjs-content">Puoi filtrare la ricerca per ottenere un risultato più preciso e trovare subito il tuo ordine.</div>',
			position: 'bottom'
		},
		{
			element: '#step_orderList_two',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Consulta l\'elenco</span></h3></div><div class="introjs-content">Per ogni ordine visualizzi le principali informazioni e lo stato di consegna: al click accedi alla scheda di dettaglio.</div>',
			position: 'top',
			scrollTo: 'tooltip'
		},
		{
			element: '#step_orderList_three',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Stato dell\'ordine</span></h3></div><div class="introjs-content">Puoi seguire tutto l’iter di un ordine monitorandone ogni fase, dall’arrivo alla consegna.</div>',
			position: 'bottom',
			scrollTo: 'tooltip'
		}
	];

	static ORDER_DETAILS = 'orderDetails';

	static ORDER_DETAILS_STEPS = [
		{
			element: '#step_orderDetail_zero',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Informazioni generali</span></h3></div><div class="introjs-content">Hai un pannello con i principali dati del veicolo, lo stato di consegna, la date di preparazione dell’ordine e il centro.</div>',
			position: 'top'
		},
		{
			element: '#step_orderDetail_one',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Barra Alert</span></h3></div><div class="introjs-content">Il contatore a sinistra ti segnala se ci sono nuovi messaggi da leggere riguardo all’ordine. Il pulsante di destra apre il form per crearne uno nuovo ed inviarlo ad ALD.</div>',
			position: 'top'
		},
		{
			element: '#step_orderDetail_two',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Tab approntamento</span></h3></div><div class="introjs-content">Qui visualizzi i dettagli richiesti per il passaggio dell’ordine alla fase di consegna. Le voci vengono validate con l’uso dello switch o delle segnalazioni.</div>',
			position: 'top-middle-aligned'
		},
		{
			element: '#step_orderDetail_three',
			intro: '<div class="introjs-head"><img class="wizard-header-pic wizard-tutor amd-icon--aligned" src="/assets/images/wizard/tutor.png" alt="ALD NEMO"><h3><span class="introjs-subtitle">Assistente</span><span class="introjs-title">Tab Consegna</span></h3></div><div class="introjs-content">Terminata la fase di approntamento, questa tab risulta visibile ed è compilabile con i dati necessari per generare l’attestato di consegna.</div>',
			position: 'top-middle-aligned'
		}
	];

	static getSteps(page: string): any | null {
		if (page === WizardSteps.DELIVERY_DASHBOARD) {
			return WizardSteps.DELIVERY_DASHBOARD_STEPS;
		}
		if (page === WizardSteps.ORDERS_LIST) {
			return WizardSteps.ORDERS_LIST_STEPS;
		}
		if (page === WizardSteps.ORDER_DETAILS) {
			return WizardSteps.ORDER_DETAILS_STEPS;
		}
	}
}
